import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/ic_暂无数据.svg'


const _hoisted_1 = { class: "view1" }
const _hoisted_2 = {
  class: "view2 radius-view1 main-view",
  style: {"height":"90%"}
}
const _hoisted_3 = { style: {"position":"relative","margin-top":"20px"} }
const _hoisted_4 = { style: {"font-size":"12px"} }

export function render(_ctx, _cache) {
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_alert, {
        closable: false,
        title: "用户航班积分兑换审核，一键操作如果已审核过的数据不会重复审核。",
        type: "warning"
      }),
      _createVNode(_component_el_form, {
        ref: "searlf",
        style: {"margin-top":"30px"},
        inline: true,
        model: _ctx.search,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "用户昵称",
            class: "form-item",
            prop: "nickName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search.nickName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.search.nickName) = $event)),
                class: "form-item-view",
                placeholder: "通过用户昵称搜索"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "开放ID",
            class: "form-item",
            prop: "openId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search.openId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.search.openId) = $event)),
                class: "form-item-view",
                placeholder: "通过开放ID搜索"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "兑换姓名",
            class: "form-item",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.search.name) = $event)),
                class: "form-item-view",
                placeholder: "通过兑换姓名搜索"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "兑换航班",
            class: "form-item",
            prop: "hangban"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search.hangban,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.search.hangban) = $event)),
                class: "form-item-view",
                placeholder: "通过兑换航班搜索"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "航班日期",
            class: "form-item",
            prop: "date"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search.date,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.search.date) = $event)),
                class: "form-item-view",
                placeholder: "通过航班日期搜索"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "目的地",
            class: "form-item",
            prop: "address"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search.address,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.search.address) = $event)),
                class: "form-item-view",
                placeholder: "通过目的地搜索"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "状态",
            class: "form-item",
            prop: "deleted"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.search.status,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.search.status) = $event)),
                class: "form-item-view",
                placeholder: "审核状态"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "待审核",
                    value: 0
                  }),
                  _createVNode(_component_el_option, {
                    label: "审核通过",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "审核失败",
                    value: 2
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[7] || (_cache[7] = $event => (_ctx.getList(1)))
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("搜索")
          ])),
          _: 1
        }),
        _createVNode(_component_el_popconfirm, {
          onConfirm: _cache[8] || (_cache[8] = $event => (_ctx.yijianChangeStatus(1))),
          title: "一键通过后，将发放积分到用户账户"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "success",
              disabled: _ctx.selectList.length==0
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("一键通过")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_popconfirm, {
          onConfirm: _cache[9] || (_cache[9] = $event => (_ctx.yijianChangeStatus(2))),
          title: "一键拒绝后，申请没有任何积分"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              disabled: _ctx.selectList.length==0
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("一键拒绝")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("重置")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.list.list,
        border: "",
        stripe: "",
        class: "table",
        onSelectionChange: _ctx.handleSelectionChange,
        style: {"margin-top":"20px"}
      }, _createSlots({
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "selection" }),
          _createVNode(_component_el_table_column, { label: "登机牌图片" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_image, {
                onClick: $event => (_ctx.gotoImg(scope.row.img)),
                style: {"width":"40px","height":"40px","border-radius":"90px"},
                src: scope.row.img,
                class: "avatar"
              }, null, 8, ["onClick", "src"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "用户昵称"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.user.nickName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "用户ID"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.user.openId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "用户姓名"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.user.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "登机姓名"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "航班"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.hangban), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "日期"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.date), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "目的地"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.address), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "状态"
          }, {
            default: _withCtx((scope) => [
              (scope.row.status==0)
                ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("待审核")
                    ])),
                    _: 1
                  }))
                : (scope.row.status==1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("已通过")
                      ])),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "danger"
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode("已拒绝")
                      ])),
                      _: 1
                    }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "兑换时间" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.dateFormat(scope.row.createTime, 'yyyy年M月d日 HH点mm分')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "审核时间" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.changeTime ? _ctx.dateFormat(scope.row.changeTime, 'yyyy年M月d日 HH点mm分') : ''), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx((scope) => [
              (scope.row.status==0)
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 0,
                    onConfirm: $event => (_ctx.changeStatus(scope.row,1)),
                    title: "通过后，将发放积分到用户账户"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "text",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("通过")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true),
              (scope.row.status==0)
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 1,
                    onConfirm: $event => (_ctx.changeStatus(scope.row,2)),
                    title: "拒绝后，本次申请没有任何积分"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        style: {"color":"#ff0000"},
                        type: "text",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("拒绝")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (_ctx.list.list.length>0)
          ? {
              name: "empty",
              fn: _withCtx(() => [
                _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"color":"#C0C4CC"} }, [
                  _createElementVNode("div", { style: {"text-align":"center"} }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      style: {"height":"100px","width":"100px"}
                    }),
                    _createElementVNode("div", null, " 暂无数据 ")
                  ])
                ], -1))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["data", "onSelectionChange"]),
      (_ctx.list.total>0)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            type: "flex",
            align: "middle",
            style: {"width":"100%","margin-top":"20px","padding-bottom":"40px"},
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, " 共" + _toDisplayString(_ctx.list.total) + "条 ", 1),
              _createVNode(_component_el_pagination, {
                background: "",
                layout: "prev, pager, next",
                "page-size": _ctx.search.ps,
                "current-page": _ctx.search.pi,
                onCurrentChange: _cache[10] || (_cache[10] = $event => (_ctx.getList($event))),
                total: _ctx.list.total
              }, null, 8, ["page-size", "current-page", "total"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}